import React, { Component } from 'react'

export default class TFA extends Component {
    constructor(props) {
        super(props)

        this.state = {
            checkValue: '',
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    render() {
        return (
            <div className="tfa-new">
                {this.tfaTitle()}
                {this.tfaInfo()}
                <button
                    className="tfa-new__button __check"
                    style={{ marginLeft: '0' }}
                    onClick={this.props.switchCheckDisplay}
                >
                    {this.translation['edit']}
                </button>
            </div>
        )
    }

    tfaTitle = () => {
        let { twoFaType } = this.props
        let title = ''

        if (twoFaType !== 'none') {
            title = this.translation[
                'Your data is protected by two-factor authentication'
            ]
        } else {
            title = this.translation[
                'Your data is not protected by two-factor authentication'
            ]
        }

        return <p className="tfa-new__title">{title}</p>
    }

    tfaInfo = () => {
        let { twoFaType } = this.props

        if (twoFaType === 'none') return null

        return (
            <p className="tfa-new__info">
                {this.translation['Type of two-factor authentication']}:{' '}
                <span>
                    {twoFaType === 'ga'
                        ? 'google authenticator'
                        : twoFaType === 'sms'
                        ? 'SMS'
                        : twoFaType}
                </span>
            </p>
        )
    }
}
